export class DsFormInstanceTableColumn {
  /**
   * Index of column
   */
  index: number;

  /**
   * Value of column
   */
  value: string | number;

  /**
   * DsFormInstanceTableColumn constructor.
   *
   * @param index number Index of column
   * @param value string | numbet value of column
   */
  constructor(index: number, value: string | number) {
    this.index = index;
    this.value = value;
  }
}
